import { AmenityViewModel } from 'models';

export function setIcon(amenityModel: AmenityViewModel, icon: string): AmenityViewModel {
  const amenity = { ...amenityModel };
  amenity.icon = icon;

  return amenity;
}

enum AMENITY_ICON {
  INCLUDES_AMENITIES_ABOVE = '',
  INCLUDES_AMENITIES_ABOVE_PLUS = '',
  HIGH_SPEED_INTERNET = 'wifi',
  FREE_INTERNET = 'wifi',
  FREE_PUBLIC_WIFI = 'wifi',
  WIFI_SURCHARGE = 'wifi',
  INTERNET_SURCHARGE = 'wifi',
  IN_ROOM_INTERNET = 'wifi',
  FREE_WIRED_INTERNET = 'wifi',
  WIRED_INTERNET_SURCHARGE = 'wifi',
  INTERNET_NOT_AVAILABLE = 'wifi',
  AIR_CONDITIONING = 'ac_unit',
  BREAKFAST = 'free_breakfast',
  FREE_BREAKFAST = 'free_breakfast',
  BREAKFAST_AVAILABLE = 'free_breakfast',
  BREAKFAST_NOT_AVAILABLE = 'free_breakfast',
  BREAKFAST_INCLUDED = 'free_breakfast',
  PETS_ALLOWED = 'pets',
  PARKING = 'local_parking',
  FREE_PARKING = 'local_parking',
  AIRPORT_TRANSPORTATION = 'airport_shuttle',
  FREE_AIRPORT_TRANSPORTATION = 'airport_shuttle',
  SPA_SERVICES_ON_SITE = 'spa',
  KITCHEN = 'kitchen',
  FITNESS_EQUIPMENT = 'fitness_center',
  BUSINESS_SERVICES = 'business_center',
  ROOM_SERVICE = 'room_service',
  RESTAURANT_IN_HOTEL = 'local_dining',
  RESTAURANTS = 'local_dining',
  CAFES = 'local_dining',
  POOL = 'pool',
  POOLS = 'pool',
  INDOOR_POOL = 'pool',
  OUTDOOR_POOL = 'pool',
  BABYSITTING = 'child_friendly',
  WASHER = 'local_laundry_service',
  LAUNDRY = 'local_laundry_service',
  CHILDREN_CLUB = 'done',
  ALL_INCLUSIVE = 'all_inclusive',
  ACCESSIBLE_ROLL_IN_SHOWER = 'accessible',
  ACCESSIBLE = 'accessible',
  FRONT_DESK_24_HOURS = 'local_convenience_store',
  BAR = 'local_bar',
  HOT_TUB = 'hot_tub',
  DAILY_HOUSEKEEPING = 'done',
  SMOKE_FREE = 'smoke_free',
  SPECIAL_DEAL = 'redeem',
  LOCATION_CITY = 'location_city',
  WATER = 'water',
  NATURE = 'nature',
  TERRAIN = 'terrain',
  OUTDOOR_SPACE = 'patio',
  PATIO = 'patio',
  FIRE_PLACE = 'fireplace',
  HOTEL = 'bed',
  PEOPLE = 'people',
  DRYER = 'dryer',
  BARBECUE = 'bbq_grill',
  DIMENSION = 'dimension',
  BEDROOM = 'room',
  BATHROOM = 'bathroom',
  MARKETING_FEE_BUSINESS_MODEL = 'credit_card',
  MARKETING_FEE_TIER_ONE = 'commission_tier_one',
  MARKETING_FEE_TIER_TWO = 'commission_tier_two',
  MARKETING_FEE_TIER_THREE = 'commission_tier_three',
  MARKETING_FEE_TIER_FOUR = 'commission_tier_four'
}

export function addIcon(amenityModel: AmenityViewModel): AmenityViewModel {
  const amenity = { ...amenityModel };
  amenity.icon = AMENITY_ICON[amenity.category] === undefined ? 'done' : AMENITY_ICON[amenity.category];

  return amenity;
}

/** Legacy Amenity Comparator
 * Because of the Bex Migration and compatibility with all of our LOBs we are moving away from the enum integer values that are mapped in
 * the BFF and transitioning to using the string values that return from the LSCS directly.
 */

enum AMENITY_LEGACY_MAPPING {
  pool = '7',
  freeParking = '14',
  freeBreakfast = '16',
  petsAllowed = '17',
  highSpeedInternet = '19',
  airConditioning = '27',
  allInclusive = '30',
  freeAirportTransport = '66',
  hotTub = '70',
  waterPark = '71',
  oceanView = '72',
  kitchen = '73',
  spaOnSite = '74',
  casino = '75',
  laundryFacility = '76',
  kitchenKitchenette = '77',
  hotSpring = '78'
}

export function amenityLegacyEquals(amenity1, amenity2): boolean {
  if (isNaN(amenity1)) {
    if (isNaN(amenity2)) {
      return amenity1 === amenity2;
    } else {
      return AMENITY_LEGACY_MAPPING[amenity1] === amenity2;
    }
  } else if (isNaN(amenity2)) {
    return AMENITY_LEGACY_MAPPING[amenity2] === amenity1;
  } else {
    return amenity1 === amenity2;
  }
}
